module.exports = __webpack_public_path__ + "img/bg_sgyl.e1b44c7a.svg";